

export enum PAGE_URLS {
	LANDING_PAGE = 'landing-page', // TEMP: url for landing page testing
	SEARCH = 'search',
	LOG_IN = 'login',
	SIGN_UP = 'signup',
	SIGN_UP_INSTRUCTOR = 'signup-instructor',
	RESET_PASSWORD = 'reset-password',
	PASSWORD_RESET = 'password-reset',
	THANK_YOU = 'thank-you',
	VERIFY_EMAIL = 'verify-email',
	VERIFY_INSTRUCTOR_EMAIL = 'verify-instructor-email',
	CONTACT_US = 'contact-us',
	FAQ = 'faq',

	INSTRUCTOR = 'instructor',

	DASHBOARD_CUSTOMER = 'dashboard',
	DASHBOARD_PROFILE = 'dashboard-profile',
	DASHBOARD_CHAT = 'chat',
	DASHBOARD_REVIEWS = 'dashboard-reviews',
	DASHBOARD_BOOKINGS = 'dashboard-bookings',
	DASHBOARD_EARNINGS = 'dashboard-earnings',

	DASHBOARD_TOOL = 'dashboard-tool',

	TRANSACTION_COMPLETE = 'transaction',
	TRANSACTION_SUCCESS = 'transaction-success',
	TRANSACTION_FAILED = 'transaction-failed',

	CREATE_NEW_CHAT = 'create-chat',

	TERMS_AND_CONDITIONS = 'terms-and-conditions',
	PRIVACY = 'privacy',

	ADMIN = 'admin',
	ADMIN_LOGIN = 'admin-login',
	ADMIN_CUSTOMER = 'admin-customer',
	ADMIN_ALL_CUSTOMERS = 'admin-all-customers',
	ADMIN_INSTRUCTOR = 'admin-instructor',
	ADMIN_ALL_INSTRUCTOR = 'admin-all-instructor',
	ADMIN_REVIEWS = 'admin-reviews',
	ADMIN_CHATS = 'admin-chats',
	ADMIN_CHAT = 'admin-chat',

	APP_ENTRY = 'app-entry',
	APP_LOGIN = 'app-login',
	APP_SIGN_UP = 'app-signup',
	APP_PASSWORD_RESET = 'app-password-reset',

	APP_EXPLORE = 'app-explore',

	APP_LESSONS = 'app-lessons',

	APP_COMMUNITIES = 'app-communities',
	APP_COMMUNITY = 'app-community',

	APP_PROFILE = 'app-profile',
	APP_PROFILE_USER = 'app-profile-user',
	APP_SETTINGS = 'app-settings',

	APP_INSTRUCTOR = 'app-instructor',
	APP_INSTRUCTOR_PICS = 'app-instructor-pics'
}